'use client';

import { ChakraProvider } from '@chakra-ui/react';
import { omniSystem } from '../../theme/omni-theme';
import { ColorModeProvider, type ColorModeProviderProps } from './color-mode';

export const Provider = (props: ColorModeProviderProps) => {
  return (
    <ChakraProvider value={omniSystem}>
      <ColorModeProvider {...props} />
    </ChakraProvider>
  );
};
